import { Heading, Stack } from '@chakra-ui/react';
import {
  CashIcon,
  HomeIcon,
  MapIcon,
  OfficeBuildingIcon,
  UserGroupIcon,
} from '@heroicons/react/outline';
import { useLocation } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';
import { NavGroupItem } from '@blockpulse3/ui/commons';

type Props = unknown;

export function SettingsNavAdmin(): JSX.Element {
  const i18nSidebar = useTranslations('Sidebar');

  const { pathname } = useLocation();

  const manageRoute = routes.admin.href;
  const graphqlRoute = routes.admin.graphql.full;
  const fundraisingsRoute = routes.admin.fundraisings.full;
  const companiesRoute = routes.admin.companies.full;
  const individualsRoute = routes.admin.individuals.full;

  return (
    <Stack pt="6" spacing="0.5">
      <NavGroupItem
        active={pathname === manageRoute}
        href={manageRoute}
        icon={<HomeIcon height="18" width="18" />}
        label={i18nSidebar('HomeTitle')}
      />
      <Heading as="h4" color="whiteAlpha.700" fontSize="xs" fontWeight="bold" pb="1" pl="3" pt="4">
        {i18nSidebar('Identities')}
      </Heading>
      <NavGroupItem
        active={pathname === companiesRoute}
        href={companiesRoute}
        icon={<OfficeBuildingIcon height="18" width="18" />}
        label={i18nSidebar('Companies')}
      />
      <NavGroupItem
        active={pathname === individualsRoute}
        href={individualsRoute}
        icon={<UserGroupIcon height="18" width="18" />}
        label={i18nSidebar('Individuals')}
      />
      <Heading as="h4" color="whiteAlpha.700" fontSize="xs" fontWeight="bold" pb="1" pl="3" pt="4">
        {i18nSidebar('Operations')}
      </Heading>
      <NavGroupItem
        active={pathname === fundraisingsRoute}
        href={fundraisingsRoute}
        icon={<CashIcon height="18" width="18" />}
        label={i18nSidebar('Fundraisings')}
      />
      <Heading as="h4" color="whiteAlpha.700" fontSize="xs" fontWeight="bold" pb="1" pl="3" pt="4">
        {i18nSidebar('Developer')}
      </Heading>
      <NavGroupItem
        active={pathname === graphqlRoute}
        href={graphqlRoute}
        icon={<MapIcon height="18" width="18" />}
        label={i18nSidebar('GraphQLExplorer')}
      />
    </Stack>
  );
}

export type SettingsNavAdminProps = Props;
